import { createSelector } from '@ngrx/store';

import * as userRemindersReducer from '../reducers/user-reminders.reducer';
import { getUserRemindersState } from '../../../../app/store';

export const isUpdatingUserReminders = createSelector(
  getUserRemindersState,
  userRemindersReducer.userRemindersUpdating
);
